module.exports = __webpack_public_path__ + "img/img78.def02757.svg";